export default __webpack_public_path__ + "static/pharaoh-27110f0a4e351b45437873fca1ab0616.jpg";